/**
 * Mobile Image Zoom Lightbox
 * Tap a product image on mobile → fullscreen lightbox with pinch-to-zoom.
 * Uses Swiper's built-in zoom module (already loaded via swiper-bundle).
 * Bottom nav: prev / close / next.
 * Only active below 750px.
 */
(function () {
  'use strict';

  var lightboxEl = null;
  var lightboxSwiper = null;
  var hintTimer = null;

  function isMobile() {
    return window.innerWidth < 750;
  }

  /**
   * Build the lightbox DOM (once, on first open)
   */
  function createLightbox() {
    var el = document.createElement('div');
    el.className = 'mobile-zoom-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Image zoom');
    el.innerHTML =
      '<div class="mobile-zoom-lightbox__hint">Pinch to zoom</div>' +
      '<div class="swiper mobile-zoom-swiper">' +
        '<div class="swiper-wrapper"></div>' +
      '</div>' +
      '<div class="mobile-zoom-lightbox__nav">' +
        '<button class="mobile-zoom-lightbox__prev" aria-label="Previous image">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
            '<polyline points="15 18 9 12 15 6"></polyline>' +
          '</svg>' +
        '</button>' +
        '<button class="mobile-zoom-lightbox__close" aria-label="Close zoom">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
            '<line x1="18" y1="6" x2="6" y2="18"></line>' +
            '<line x1="6" y1="6" x2="18" y2="18"></line>' +
          '</svg>' +
        '</button>' +
        '<button class="mobile-zoom-lightbox__next" aria-label="Next image">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
            '<polyline points="9 18 15 12 9 6"></polyline>' +
          '</svg>' +
        '</button>' +
      '</div>';

    document.body.appendChild(el);

    el.querySelector('.mobile-zoom-lightbox__close').addEventListener('click', closeLightbox);
    el.querySelector('.mobile-zoom-lightbox__prev').addEventListener('click', function () {
      if (lightboxSwiper) lightboxSwiper.slidePrev();
    });
    el.querySelector('.mobile-zoom-lightbox__next').addEventListener('click', function () {
      if (lightboxSwiper) lightboxSwiper.slideNext();
    });

    return el;
  }

  /**
   * Update prev/next button disabled state
   */
  function updateNavButtons(swiper, total) {
    if (!lightboxEl) return;
    var prev = lightboxEl.querySelector('.mobile-zoom-lightbox__prev');
    var next = lightboxEl.querySelector('.mobile-zoom-lightbox__next');
    if (prev) {
      if (swiper.activeIndex === 0) prev.classList.add('is-disabled');
      else prev.classList.remove('is-disabled');
    }
    if (next) {
      if (swiper.activeIndex >= total - 1) next.classList.add('is-disabled');
      else next.classList.remove('is-disabled');
    }
  }

  /**
   * Collect all real (non-duplicate) image sources from the mobile gallery
   */
  function collectImages() {
    var gallery = document.querySelector('.product__mobile-hero-media product-gallery');
    if (!gallery) return [];

    var slides = gallery.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
    var images = [];
    var seenSrc = {};

    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;

      var src = img.currentSrc || img.src;
      if (img.srcset) {
        var parts = img.srcset.split(',');
        var last = parts[parts.length - 1].trim().split(' ')[0];
        if (last) src = last;
      }

      if (seenSrc[src]) return;
      seenSrc[src] = true;

      images.push({ src: src, alt: img.alt || '' });
    });

    return images;
  }

  /**
   * Find which real-slide index matches the tapped slide.
   * Uses the slide's position in the DOM (or data-swiper-slide-index
   * for loop-mode duplicates) instead of fragile filename matching.
   */
  function findSlideIndex(slide, gallery) {
    /* Loop-mode duplicates carry a data-swiper-slide-index attr */
    var loopIdx = slide.getAttribute('data-swiper-slide-index');
    if (loopIdx !== null) return parseInt(loopIdx, 10);

    /* Otherwise count its position among real (non-duplicate) slides */
    var realSlides = gallery.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
    for (var i = 0; i < realSlides.length; i++) {
      if (realSlides[i] === slide) return i;
    }
    return 0;
  }

  /**
   * Open the lightbox starting at a given slide
   */
  function openLightbox(startIndex) {
    var images = collectImages();
    if (images.length === 0) return;

    if (!lightboxEl) lightboxEl = createLightbox();

    var wrapper = lightboxEl.querySelector('.swiper-wrapper');
    wrapper.innerHTML = '';

    images.forEach(function (img) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.innerHTML =
        '<div class="swiper-zoom-container">' +
          '<img src="' + img.src + '" alt="' + img.alt.replace(/"/g, '&quot;') + '" />' +
        '</div>';
      wrapper.appendChild(slide);
    });

    if (startIndex >= images.length) startIndex = 0;

    lightboxEl.classList.add('active');
    document.body.style.overflow = 'hidden';

    var total = images.length;

    var hint = lightboxEl.querySelector('.mobile-zoom-lightbox__hint');
    if (hint) {
      hint.classList.remove('mobile-zoom-lightbox__hint--hidden');
      clearTimeout(hintTimer);
      hintTimer = setTimeout(function () {
        hint.classList.add('mobile-zoom-lightbox__hint--hidden');
      }, 2000);
    }

    var prev = lightboxEl.querySelector('.mobile-zoom-lightbox__prev');
    var next = lightboxEl.querySelector('.mobile-zoom-lightbox__next');
    if (total <= 1) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
    } else {
      if (prev) prev.style.display = '';
      if (next) next.style.display = '';
    }

    if (lightboxSwiper) {
      lightboxSwiper.destroy(true, true);
      lightboxSwiper = null;
    }

    lightboxSwiper = new Swiper(lightboxEl.querySelector('.mobile-zoom-swiper'), {
      initialSlide: startIndex,
      slidesPerView: 1,
      spaceBetween: 0,
      zoom: {
        maxRatio: 3,
        minRatio: 1
      },
      on: {
        init: function () {
          updateNavButtons(this, total);
        },
        slideChange: function () {
          updateNavButtons(this, total);
        },
        zoomChange: function () {
          if (hint) hint.classList.add('mobile-zoom-lightbox__hint--hidden');
        }
      }
    });
  }

  /**
   * Close the lightbox
   */
  function closeLightbox() {
    if (!lightboxEl) return;
    if (lightboxSwiper) lightboxSwiper.zoom.out();

    lightboxEl.classList.remove('active');
    document.body.style.overflow = '';
  }

  /**
   * Add ONE magnifying glass icon on the gallery wrapper (not inside slides).
   * This keeps it fixed in the bottom-right while slides swipe underneath.
   */
  function addZoomHint(galleryWrapper) {
    if (galleryWrapper.querySelector('.mobile-zoom-hint')) return;

    var hint = document.createElement('div');
    hint.className = 'mobile-zoom-hint';
    hint.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
        '<circle cx="10.5" cy="10.5" r="6.5"></circle>' +
        '<line x1="15.5" y1="15.5" x2="20" y2="20"></line>' +
        '<line x1="8" y1="10.5" x2="13" y2="10.5"></line>' +
        '<line x1="10.5" y1="8" x2="10.5" y2="13"></line>' +
      '</svg>';
    galleryWrapper.appendChild(hint);
  }

  /**
   * Initialise: attach tap handler to mobile gallery
   */
  function init() {
    if (!isMobile()) return;

    var galleryWrapper = document.querySelector('.product__mobile-hero-media');
    var gallery = galleryWrapper ? galleryWrapper.querySelector('product-gallery') : null;
    if (!gallery || gallery.dataset.zoomInit) return;
    gallery.dataset.zoomInit = 'true';

    /* Add magnifying glass to the wrapper (stays fixed while swiping) */
    addZoomHint(galleryWrapper);

    /* Track touch movement to distinguish tap from swipe */
    var touchMoved = false;
    gallery.addEventListener('touchstart', function () { touchMoved = false; }, { passive: true });
    gallery.addEventListener('touchmove', function () { touchMoved = true; }, { passive: true });

    gallery.addEventListener('click', function (e) {
      if (touchMoved) return;

      var slide = e.target.closest('.swiper-slide');
      if (!slide) return;

      var img = slide.querySelector('img');
      if (!img) return;

      var idx = findSlideIndex(slide, gallery);
      openLightbox(idx);
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
